import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';
import LeftSideMenu from '../../../components/MenuManager/Left';
import Utils from '../../../utils';
import AuthUtils from '../../../utils/authentication';
import UserAgentUtils from '../../../utils/userAgent';
import { MenuItem, MenuItemType } from '../../../typings/menu';

const mapStateToProps = ({
	menuManager,
	authentication,
	appInfos,
	backToPublication: {
		publicationId: lastPublicationId
	},
	galleryInfos,
	galleryInfos: {
		config: galleryConfig
	},
	newDriveItems,
	driveList,
	profile,
}: StoreState) => {
	const privateDirId = Utils.getPrivateDirId(driveList, galleryConfig);
	const sharedDirId = Utils.getSharedDirId(driveList, galleryConfig);
	const archiveDirId = Utils.getArchiveDirId(driveList, galleryConfig);
	const { mode } = authentication.userInfos;
	const { menuModes, leftMenuIsOpen } = menuManager;
	const { burger } = menuModes;

	const isMultiApp = Utils.isMultiApp(appInfos);
	const isMobileApp = UserAgentUtils.isMobileApp;
	const isConnectedSingleApp = !isMultiApp && !AuthUtils.isSaml(mode) && AuthUtils.isConnected(mode);
	const isReadOnlyApp = Utils.isReadOnlyApp(profile.role);
	const isGalleryButtonNeeded = galleryInfos.isConfigLoaded && Utils.isTemplateLoaded(appInfos, galleryInfos) && galleryInfos.template.welcomepage;
	const newItemsNb = newDriveItems.ids.length;
	const hasLogOutButton = isMobileApp && isConnectedSingleApp;
	const hasProfile = isMultiApp;
	const hasProposalStatsPage = isMultiApp && !!privateDirId;
	const hasCreateNoteButton = Object.values(menuModes).some(menuPosition => (
		menuPosition.some(({ type }: MenuItem) => type === MenuItemType.CreateNote)
	));
	const hasNotesPage = isMultiApp && hasCreateNoteButton;

	const hasCookieSettings = galleryInfos.template.cookie && galleryInfos.template.cookie.enabled === 'true' && galleryInfos.template.cookie.gdpr === 'true';

	const hasLastPublication = !!lastPublicationId;

	let filteredMenuItems = burger.filter(item => {
		switch (item.type) {
			case MenuItemType.Gallery:
				return isGalleryButtonNeeded;
			case MenuItemType.New:
				return UserAgentUtils.isOnline() || !Utils.isMaster(galleryInfos.config);
			case MenuItemType.Downloads:
				return isMobileApp;
			case MenuItemType.CreateButton:
				return isMultiApp && !!privateDirId && !isReadOnlyApp;
			case MenuItemType.Documents:
				return isMultiApp && !isReadOnlyApp;
			case MenuItemType.BackToPublication:
				return hasLastPublication;
			default:
				return item;
		}
	});

	return {
		isOpen: leftMenuIsOpen,
		newItemsNb,
		filteredMenuItems,
		hasLogOutButton,
		hasProfile,
		hasProposalStatsPage,
		hasCookieSettings,
		hasNotesPage,
		privateDirId,
		sharedDirId,
		archiveDirId,
		isProfileLoaded: hasProfile && !!profile.clientId,
		hasDownloads: isMobileApp &&
			isReadOnlyApp &&
			!filteredMenuItems.some(({ type }) => type === MenuItemType.Downloads),
	};
};

export default connect(mapStateToProps)(LeftSideMenu);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/MenuManager/Left/index.tsx